import { render, staticRenderFns } from "./NExpansionpanels.vue?vue&type=template&id=da8ee254&"
import script from "./NExpansionpanels.vue?vue&type=script&lang=js&"
export * from "./NExpansionpanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports